module.exports = __webpack_public_path__ + "img/right1.7ef77e9b.png";